<template>
  <div class="powered-box">
    <p class="d-inline-block">POWERED BY</p>
    <a href="https://phelcom.com/" class="logo d-inline-block" target="_blank" data-test="anchorPhelcomLink">
      <img src="@/assets/images/phelcom/phelcom_logo_horizontal_blue.svg" alt="Logo Phelcom">
    </a>
    <img class="aws-logo" src="@/assets/images/erjart/logo_aws.svg" alt="Logo AWS">
    <p class="d-inline-block">v {{ appVersion }}</p>
  </div>
</template>

<style lang="scss" scoped>
.powered-box {
  display:                             flex;
  justify-content:                     flex-end !important;
  align-items:                         center;

  p {
    color:                             var(--Brand-Primary, #1B294A);
    font-size:                         var(--font-size-8);
    font-weight:                       400;
    letter-spacing:                    2.15px;
    margin:                            0;
  }
  .logo {
    color:                             #1B294A;
    width:                             101px;
    margin:                            0;
    text-decoration:                   none;
  }
}

@media (max-width: 991px) {
  .powered-box {
    justify-content:                   center;
  }
}
</style>

<script>
export default {
  name: 'AuthPoweredBy',
  data: () => ({
    appVersion: process.env.VUE_APP_VERSION,
  }),
  mounted() {
    console.log('criou');
  }
}
</script>
